import './style';
import { Component } from 'preact';
import { Router } from 'preact-router';
// import Match from 'preact-router/match';
import Header from './components/Header';
import WorldMap from './components/WorldMap';
import MapControls from './components/MapControls';
import Country from './components/Country';
import { getCountries } from './lib/countries';
// import { getIcons } from './lib/icons';
import { parsePath, currentPath, setRoute } from './lib/utils';

// function currentCountry () {
//   const path = window.location.pathname;

//   return path.slice(-3,-2) === '/' && path.slice(-2) || null;
// }


// Redirect hash URLs
function redirectHashUrl () {
  const { hash } = window.location;

  if (hash && hash.length > 1) {
    const { countryId, year } = parsePath(hash.slice(1));
    
    setRoute(year, countryId, true);
    return true;
  }
}

// minimal-ui for iOS 
// let viewportMeta = document.querySelector('head meta[name="viewport"]');

// if (viewportMeta) {
//   let content = viewportMeta.getAttribute('content') || '';

//   content += (content ? ', ' : '') + 'minimal-ui';
//   viewportMeta.setAttribute('content', content);
// }

// else {
//   viewportMeta = document.createElement('meta');
//   viewportMeta.setAttribute('name', 'viewport');
//   viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1, minimal-ui');
//   document.querySelector('head').appendChild(viewportMeta);
// }

export default class App extends Component {
  constructor (props) {
    super(props);

    // getIcons()
    // .then(icons => {
    //   document.body.insertBefore(icons, document.body.firstChild);
    // });

    getCountries()
    .then(countries => {
      const yearRange = Object.keys(countries).reduce((result, countryId) => {
        const years = Object.keys(countries[countryId].eventsByYear).sort().map(Number);
        const firstYear = years[0];
        const lastYear = years[years.length - 1];

        if (firstYear < result.minYear) {
          result.minYear = firstYear;
        }

        if (lastYear > result.maxYear) {
          result.maxYear = lastYear;
        }

        return result;
      }, { minYear: Infinity, maxYear: 0 });

      this.setState({ countries, ...yearRange });
    });
  }

  state = {
    countries: null,
    minYear: null,
    maxYear: null,
    ...currentPath()
  }

  handleRoute = event => {
    if (redirectHashUrl()) {
      return;
    }

    const url = event.url;

    const { countryId, year } = currentPath();
    const { countries } = this.state;

    // console.log('handleRoute', { countryId, countries: !!countries, url }, this.state.countryId);

    if (countryId && countries && !(countryId in countries)) {
      setRoute(null, null, true);
      return;
    }

    if (this.state.countryId !== countryId) {
      if (!countryId) {
        if (document.activeElement) {
          document.activeElement.blur();
        }
      }

      // console.log(`set state ${this.state.countryId} -> ${countryId}`);
      this.setState({ countryId });
    }

    if (this.state.year !== year) {
      // console.log(`set state ${this.state.year} -> ${year}`);
      this.setState({ year });
    }
  }

  setYear = (year) => {
    setRoute(year, this.state.countryId);
  }

	render () {
    const { countries, countryId, year, minYear, maxYear } = this.state;
    // console.log('index', {countries: !!countries, countryId, year, minYear, maxYear});

    if (!countries) {
      return null;
    }

    const country = countryId && countries[countryId];
    const eventsByYear = country && country.eventsByYear[year];
    const hasCommentaries = eventsByYear && eventsByYear
      .some(event => !!event.commentary);

		return (
      <div class="app">
        <MapControls
          showPan={ !countryId }
          showZoom={ !countryId }
          showYear={ true }
          showIconsLegend={ false }
          onChangeYear={ this.setYear }
          minYear={ minYear }
          maxYear={ maxYear }
          year={ year }
        />

        <Router onChange={this.handleRoute}>
          <div id="content" path="/:countryId?/:year?">
            <Header />

            <main class={ hasCommentaries && 'has-commentaries' }>
              <WorldMap selectedCountry={ countryId } countries={ countries } year={ year || maxYear } />

              <Country country={ country } year={ year || maxYear } />
            </main>

            <footer>
              <a class="org" href="https://aru.ac.uk/global-sustainability-institute-gsi/research/global-risk-and-resilience/global-chaos-map-project/about" target="_blank">
                About
              </a>

              <div class="download">
                <a native download="aru-chaosmap.csv" href="/assets/data/aru-chaosmap.csv">Download data</a>
              </div>
            </footer>
          </div>
        </Router>
      </div>
		);
	}
}



// WEBPACK FOOTER //
// ./index.js